import axios from "axios";
import OutConst from "../customEventOutConst.js";
import CONSTNAME from "@/ConstName.js";
import * as utils from "@/utils/ganttUnit.js";
const action = {
  // 选中行
  selectTaskBg(store, index) {
    if (index != this.state.selectTaskIndex) {
      this.commit("setSelectTaskIndex", index);
    } else {
      // console.log("忽略:重复行");
    }
  },
  /*  缩放时间轴(本地使用)
   * 单纯缩放传{type: String} "small"或者"biger" scale可不传
   * 单纯设定值传{scale: Number} 大于0-1000数值 type可不传 尽量非必传字段都给个空值
   */
  changeCellScale(store, { type, scale }) {
    const oldScale = this.getters.realCellScale;
    if (this.getters.noGantt) {
      return alert("请先选择展示右侧甘特图");
    }
    let result = 1;
    if (type == "setScale") { // 1::直接设定值
      if (typeof scale !== "number" || scale <= 0 && scale > 1000) return console.warn("非规设置时间轴倍率", scale);
      result = scale / 100;
      if (oldScale == result) {
        return console.warn("同样倍率无需修改", result);
      } else if (scale == 8 || scale % 10 == 0) {
        console.log("设置时间轴倍率", result);
        return this.commit("setCellScale", result);
      } else {
        return console.warn("非规设置时间轴倍率", scale / 100);
      }
    } else { // 2: 步长自动缩放
      if (type == "small" && oldScale == 0.08) {
        return console.warn("宽度比例当前最小值为0.08");
      } else if (type == "small" && oldScale == 0.1) {
        result = 0.08;
      } else if (type == "small") {
        result = (parseInt(oldScale * 10) - 1) / 10;
      } else {
        result = (parseInt(oldScale * 10) + 1) / 10;
      }
    }
    this.commit("setCellScale", result);

  },

  /**
   * 苍穹调用交互
   */

  [OutConst.CUSTOM_INIT](store, obj) {
    this._invokeAsync(OutConst.CUSTOM_INIT, obj);
  },
  // 选中状态修改
  _selectNodeGtTreeList(store, arg) {
    this._invoke(OutConst.SELECT_ROW, arg);
  },
  // 选中状态集合修改
  _selectNodeGtTreeListOne(store, arg) {
    this._invoke(OutConst.SELECT_ROW_ONE, arg);
  },
  // 展开状态修改
  _expandNodeGttreelist(store, arg) {
    this._invoke(OutConst.CHANGE_EXPAND_STATUS, arg, null, this);
  },
  // 新增横道连线——特殊类型:传入第三个作为本地模拟数据所需处理额外参数
  _crossline(store, arg) {
    this._invoke(OutConst.ADD_CROSSLINE, arg.obj, arg, this);
  },

  /* 打印 */
  _sendPrintInfo(store, arg) {
    console.log("开始打印");
    const { _vm } = arg;
    const _self = this;
    // 返回服务端信息·异常关闭loading
    const _printErrInfo = {
      status: false, // 判断值
      url: "打印异常·关闭loading", // 上传接口返回路径
    };
    // step1: 异常处理
    const _showMode = _self.state.showMode;
    if (_showMode == "left") {
      _vm.$Message({
        message: "打印前请确保有右侧横道视图",
        type: "error",
        showClose: true,
      });
      _self._invoke(OutConst.START_PRINT, _printErrInfo);
      return false;
    }
    if (_self.state.printStatus) {
      _vm.$Message({
        message: "打印正在进行中,勿重复操作",
        type: "error",
        showClose: true,
      });
      _self._invoke(OutConst.START_PRINT, _printErrInfo);
      return false;
    }
    // step2: 加锁
    _self.commit("set_printStatus", true);

    // step3: 置为全内容展开节点
    const _ganttNode = document.getElementById(_self.state.uuid);
    const printNode = _ganttNode;
    // step4: 计算可用最大比率·图片质量最大化
    const _max = 16000; // 最大尺寸
    const _totalWidth = _self.getters.printTotalWidth;
    const _totalHeight = _self.getters.printTotalHeight;
    const _flag = _self.getters.printViewChangeFlag && (_totalWidth > _self.getters.ganttWidth);
    if (_flag) {
      _ganttNode.parentNode.style.width = _totalWidth + "px";
    }
    const _scaleX = Math.trunc(_max / _totalWidth * 100) / 100;
    const _scaleY = Math.trunc(_max / _totalHeight * 100) / 100;
    const _printMaxScale = _self.state.viewSchem.printMaxScale || 2;
    const scale = Math.min.call(null, _scaleX, _scaleY, _printMaxScale);
    const _timesLinesHeight = _self.state.viewSchem.ganttHeadShow ? _self.state.timesLineHeight * _self.getters.timelineShowRows : 0;
    const _printInfo = { // 返回服务端信息
      scale,
      timeLinesHeight: _timesLinesHeight,
      status: false,
      url: "",
    };
    // step5: 获取打印图片信息·
    setTimeout(() => {
      _vm.$html2canvas(printNode, {
        allowTaint: false, // 防止污染 会导致canvas数据流不可读
        useCORS: true, // 保证跨域图片的显示
        backgroundColor: "#ffffff",
        scale,
      }).then(async(canvas) => {
        _self.commit("set_printStatus", false);
        // step6: 打印步骤开始
        if (_self.state.printDebug) {
          // step6-1: 本地测试查看生成图片
          // console.log("step6-1: Debug生成图片");
          const _base64 = canvas.toDataURL("image/jpeg", 1);
          const _iframe = _ganttNode.getElementsByClassName("pmtsIframe")[0];
          _iframe.contentWindow.document.body.innerHTML = "";
          _iframe.contentWindow.document.write(
            "<html><head><style media='print'>@page { margin: 0mm 10mm; }body{margin-top: 50px; text-align: center;}</style></head><body><img src=" +
            _base64 +
            "></body></html>");
          _self._invoke(OutConst.START_PRINT, {
            scale,
            timeLinesHeight: _timesLinesHeight,
            base64: _base64,
          });
        } else {
          // step6-2: 导出图片、清理画布、上传
          canvas.toBlob(async(blob) => {
            // console.log("1:导出图片开始");
            if (blob) {
              let formData = new FormData();
              formData.append("url", "images");
              const time = new Date();
              formData.append("file", blob, `common_gantt${time.getTime()}.jpg`); // 文件名字
              const sUrl = `${window.location.origin}${window.location.pathname.replace(/\/index.html(\S*)/g, "")}/image/uploadImage.do`;
              const t1 = Date.now();
              canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
              await _vm.$axios.post(sUrl, formData, {
                "Content-type": "multipart/formData",
              }).then(res => {
                // console.log("3.1:上传处理", res);
                if (
                  res.status == 200 &&
                  res.data &&
                  res.data.status == "success"
                ) {
                  _printInfo.status = true;
                  _printInfo.url = res.data.url; // 访问示例: https://devtest.kingdee.com:2024/tgzx/image/downloadImage.do?path=/tenant_tgzx_test/1357237153058258944/202308/XUCaaxBn.jpg
                  console.log("3.1.1:上传成功");
                }

              }, err => {
                console.log("3.2:上传图片异常: ", err);

              }).finally(() => {
                // step7: 通知后台操作图片信息
                // console.log("4:画布重置", blob);
                _self._invoke(OutConst.START_PRINT, _printInfo);
                blob = null;
                formData = null;
                canvas = null;
                console.log("4.1:上传结束", Date.now() - t1);

              });
              // console.log("5:打印流程完成");
            } else {
              _self._invoke(OutConst.START_PRINT, _printErrInfo);
            }
          }, "image/jpeg", 1);
        }

      }).catch((err) => {
        _vm.$Message({
          message: "打印异常 ",
          type: "error",
          showClose: true,
        });
        console.log("step6-2:导出图片异常: ", err);
        _self._invoke(OutConst.START_PRINT, _printInfo);
        _self.commit("set_printStatus", false);
      },
      ).finally(() => {
        // 重置页面节点
        if (_flag) {
          _ganttNode.parentNode.style.width = "";
        }
        console.log("控件容器还原:", _flag, _scaleX, _scaleY, _printMaxScale, scale);
      });

    }, 100);
  },
  /*
    obj: {
      type: 设置显示模式left | both | right
      minScale: 最小填充显示比例(切换视图和调整左右尺寸会影响实际计算比例值)
    }
  */
  _changeShowMode(store, obj) {
    this._invoke(OutConst.UPDATE_GTVIEW_MODE, obj);
  },

  // 拖拽释放·横道内
  _dropInSide(store, obj) {
    this._invoke(OutConst.DROP_INSIDE, obj);
  },

  // 整体拖拽横道: 修改起止位置 taskItem = { item, index}
  _dragTask(store, taskItem) {
    this._invoke(OutConst.DRAG_TASK, taskItem, null, this);
  },
  // 修改单个横道的起止
  _adjustTask(store, taskItem) {
    this._invoke(OutConst.ADJUST_TASK, taskItem, null, this);
  },

  /* 缓存项 */
  // 更新数宽
  _set_treeWidth(store, obj) {
    this._invoke(OutConst.UPDATE_TREE_WIDTH, obj);
  },
  _set_wbsHeaderArr(store, obj) {
    this._invoke(OutConst.UPDATE_WBSHEADERARR_WIDTH, obj);
  },
  _set_InitTableWidth(store, obj) {
    this._invoke(OutConst.UPDATE_INITTABLEWIDTH, obj);
  },

  /* 编辑表单行 */
  _editRow(store, obj) {
    this._invoke(OutConst.START_EDITROW, obj);
  },
  /* 选中横道 */
  _selectTask(store, task) {
    this._invoke(OutConst.SELECT_TASK, task);
  },
  /* 双击巴条 */
  _dblclickBar(store, task) {
    const actionName = task.dblclickBarAction || OutConst.DBLCLICK_TASK;
    this._invoke(actionName, task);
  },
  /* 加载内容·更多内容 */
  _loadContent(store, info){
    this._invoke(OutConst.LOAD_CONTENT, info);
  },


  /**
   * 本地调试交互
   */
  // 加载苍穹测试数据
  loadMockCq(store, index = "") {
    console.log("加载测试数据", "/api/initGantt_cq" + index);
    const _self = this;
    axios({
      method: "post",
      url: "/api/initGantt_cq" + index,
      data: {},
    })
    .then((res) => {
      if (res.data.success === true) {
        _self.commit("initGantt", res.data);
      }
    });
  },

  // 以下俩种方式都是为了 单独起一个后台服务进行超大数据mock请求 统计性能时间，弥补超大数据mock文件无法被该开发项目编译打包通过的场景
  loadMock(store, url = "") {
    console.log("加载本地mock独立服务测试数据", "http://localhost:8000/api/" + url);
    const _self = this;
    axios({
      method: "get",
      url: "http://localhost:8000/api/" + url,
      data: {},
    })
    .then((res) => {
      console.log(res.data);
      if (res.data.success === true) {
        _self.commit("initGantt", res.data);
      }
    });
  },
  loadProxy(store, url = "") {
    console.log("加载本地Proxy mock独立服务测试数据", "http://localhost:8000/be/data/" + url);
    const _self = this;
    axios({
      method: "get",
      url: "/be/data/" + url,
      data: {},
    })
    .then((res) => {
      console.log(res.data);
      if (res.data.success === true) {
        _self.commit("initGantt", res.data);
      }
    });
  },

  // 刷新横道集合
  gtRefreshTasks(store, { arr, ganttType }) {
    console.log("刷新横道集合", { arr, ganttType });
    this.commit("setTasksArr", { arr, ganttType });
  },


  /**
   * @description: 右键菜单项注册 通用透传调用服务端
   * @param {cbName} 接口名称
   * @param {desc} 菜单显示名称
   * @param {item} 右键条目信息
   * @param {index} 右键条目序号
   * @return {*} 纯发出调用·等待回调更新通知
   */

  pureTransmit(store, { cbName, cbNumber, item, index }) {
    console.log("【透传苍穹】 菜单项:%s 接口名:%s 信息:%O 顺序:%s", cbName, cbNumber, item, index);
    this._invoke(cbNumber, item, { cbName, cbNumber, index }, this);
  },
  /* 更新分区主数据 */
  /* updateMainData(store, { taskDataList, dataList, height, yLines, dataListMap }) {
    const _ganttType = (dataList && dataList.length > 0) ? dataList[0].ganttType : CONSTNAME.PLANS;
    this.commit("setwbsRowArr", dataList); // 行
    this.commit("set_dataListMap", { dataListMap, ganttType: _ganttType }); // 字典
    this.commit("setTasksArr", { arr: taskDataList, ganttType: _ganttType }); // 横道
    this.commit("set_yLines", { yLines, ganttType: _ganttType }); // 垂直线
  }, */


  /* 搜索·定位横道 */
  getLocation(store, _item) {
    /* const _item = { // task高亮显示用 下方其他属性计算方位用
      taskId: "9104136706211224703——Task"
      startDate: 1641433095000,
      endDate: 1657109794264,
      groupId: "8113434303280661871&1455207762614124544",
      curRow: 1,
    }; */

    const _type = this.state.cellUnitType;
    const _baseWidth = this.getters.cellWidth;
    const _baseHeight = this.state.cellHeight;
    const _map = this.state[CONSTNAME.PLANS + "_map"];

    if (_map[_item.groupId]) {
      const _topNum = _map[_item.groupId].realRow + _item.curRow - 1;
      const _top = _topNum * _baseHeight;
      const _left = utils.getDiffWidth(_type, this.getters.totalStartAndEnd.start, _item.startDate, _baseWidth);

      const _ganttNode = document.getElementById(this.state.uuid);
      _ganttNode.getElementsByClassName("gantt-content")[0].scroll({
        top: _top - 20,
      });
      _ganttNode.getElementsByClassName("gantt-box")[0].scroll({
        left: _left - 50,
      });
    }
    /*
    // 非虚拟列表可用
    document.getElementById("aaa").scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest'
    });
    document.querySelector(".task[data-id='8643154502631506894——Task']").scrollIntoView(true);
    */
  },

  // 初始化搜索目标高亮
  async showSearchedTaskInit({ commit, dispatch }, arr = []) {
    if (arr instanceof Array) {
      commit("set_viewSchem_searchedList", arr);
      commit("set_searchedActNum", 0);
      if (arr[0]) {
        await dispatch("getLocation", arr[0]);
      }

    }
  },
  // 对已有搜索集合中做上下切换展示操作
  async showSearchedTaskActNum({ commit, dispatch }, index = 0) {
    const _searchedArr = this.state.viewSchem.searchedList;
    commit("set_searchedActNum", index);
    if (_searchedArr[index]) {
      await dispatch("getLocation", _searchedArr[index]);
    }
  },
  // 关闭搜索集合展示
  hideSearchedTask({ commit }) {
    commit("set_viewSchem_searchedList", []);
    commit("set_searchedActNum", 0);
  },


  // 测试新增横道数据
  addTask(store, sourseData) {
    const rowItem = {
      "cellList": [],
      "entityFlagIndex": 2,
      "isExpand": false,
      "level": 1,
      "isSelect": false,
      "parentObjId": "1403800372618754048",
      "dropable": true,
      "number": "A11",
      "pid": "5144994489901664732&1403800372618754048",
      "name": "测试新增",
      "ganttType": "pageData",
      "entityFlag": "pmts_task",
      "objId": "1405793591946669056",
      "rowType": "1",
      "childNodes": null,
      "rowCount": 1,
      "id": "add-row-5144994489901664732&1405793591946669056",
      "randomId": "0531126b-8a7b-4bf6-b551-e5f3785da500",
      "isSealf": true,
    };
    sourseData.pageData.dataList.splice(6, 0, rowItem);
    sourseData.pageData.dataListMap["add-row-5144994489901664732&1405793591946669056"] = {
      "startRow": 7 + 1,
      "realRow": 9,
      "taskEndIndex": 10 + 1,
      "name": "",
      "taskStartIndex": 9 + 1,
      "rowCount": 1,
    };
    sourseData.pageData.dataListMap.totalRow++;

    const addItem = {
      "taskId": "add-5144994489901664732&1_3_1413923549382466560_1413923549382466560",
      "groupToField": "wbs",
      "crossObjName": "task",
      "crossLevel": 4,
      "maxeEndDate": 1641260160000,
      "parentObjId": "1413923549382466560",
      "taskEntryId": "1413923549382466560",
      "position": "left",
      "adjustable": true,
      "endDate": 1641052800000 + 8640000 * 3,
      "draggable": true,
      "ganttType": "pageData",
      "highlightType": "A",
      "taskListIndex": 9,
      "starttimeToField": "planstartdate",
      "barColor": "red",
      "startDate": 1640966400000 + 8640000 * 3,
      "desc": "测试新增的展示-1212-121212--",
      "objId": "1413923549382466560",
      "crossObj": "1",
      "endtimeToField": "planenddate",
      "title": "-~-",
      "crossHeightVal": 16,
      "metaKey": "pmts_task",
      "curRow": 1,
      "crossType": "3",
      "groupId": "add-row-5144994489901664732&1405793591946669056",
      "crossId": "1406548060833637378",
      "labelIsShow": true,
      "realRow": 1,
      "isLine": true,
      "taskLink": [
      ],
    };
    sourseData.pageData.taskDataList.push(addItem);

    this.commit("initGantt", sourseData);

  },
};

export default action;
